<template>
  <base-material-card>
    <template v-slot:heading>
      <div class="subtitle-1 font-weight-light">
        Чаты:
      </div>
    </template>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          <v-text-field
              v-model="searchValue"
              denses
              placeholder="Поиск"
          >
            <v-icon
                slot="append"
            >
              mdi-magnify-scan
            </v-icon>
          </v-text-field>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-virtual-scroll
        item-height="50"
        :items="chatList"
        height="calc(100vh - 305px)"
    >
      <template v-slot:default="{ item }">
        <v-list-item
            @click="getChat(item.id)"
            :class="currentChat && item.id === currentChat.id ? 'v-list-item--active' : ''"
        >
          <v-list-item-avatar>
            <v-img
                :src="chatAvatar"
                :lazy-src="chatAvatar"
            ></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-html="item.title"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="item.unreadCommentsCount > 0">
            <v-badge
                color="success"
                inline
                :content="item.unreadCommentsCount"
            >
            </v-badge>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-virtual-scroll>
  </base-material-card>
</template>

<script>
export default {
  name: "ChatListPanel",
  computed: {
    chatList() {
      let sv = ''
      if (this.searchValue) {
        sv = this.searchValue.toLowerCase()
      }
      return this.searchValue ?
          this.$store.getters.chatList.filter(item => item.title.toLowerCase().includes(sv)) :
          this.$store.getters.chatList
    },
    currentChat() {
      return this.$store.getters.currentChat
    },
  },
  data() {
    return {
      searchValue: null,
      chatAvatar: require('@/assets/chatAvatar.png'),
    }
  },
  methods: {
    getChat(chatId) {
      if (chatId) {
        this.currentChatId = chatId
        this.$store.dispatch('retrieveChat', {chatId: chatId, commentLimit: 20}).then(() => {
          this.searchValue = null
          this.$store.dispatch('clearChatForward')
          this.$store.dispatch('clearChatCreateService')
        })
      }
    },
  }
}
</script>

<style scoped>

</style>